import React from 'react';
import {
    Box,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    List,
    ListItem, ListItemText,
    Typography
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import setTime from "../../utils/setTime";

const ScheduleInStatesCard = ({ scheduleInStates, cardClasses, expanded, handleExpand }) => {
    return (
        <>
            {scheduleInStates.map(item => {
                const { schedule, states } = item;
                const {name, timeZone, available} = schedule;
                return (
                    <ExpansionPanel
                        className={cardClasses.expansionPanel}
                        key={name}
                        expanded={expanded === name}
                        onChange={handleExpand(name)}
                    >
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls={`${name}-content`}
                            id={`${name}-header`}
                        >
                            <Typography variant="body2" paragraph>
                                <strong>Name</strong>: {name}
                            </Typography>
                            <Typography variant="body2" paragraph>
                                <strong>Timezone</strong>: {timeZone}
                            </Typography>
                            {states ? (
                                <>
                                    <Typography variant="body2" paragraph>
                                        <strong>States</strong>:
                                    </Typography>
                                    <Box style={{ height: '130px', overflowY: 'scroll', padding: '0 10px', border: '1px solid #ddd'}}>
                                        {states.map(state => (
                                            <p>
                                                {state}
                                            </p>
                                        ))}
                                    </Box>
                                </>
                            ) : null}
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <List>
                                <Typography variant="body2" paragraph>
                                    <strong>Schedule</strong>:
                                </Typography>
                                {available.map((day, idx) => {
                                    const {ranges, dayOfWeek} = day;
                                    return (
                                        <ListItem key={idx.toString()}>
                                            <ListItemText>
                                                <Box display="flex" alignItems="flexStart"
                                                     flexDirection="row" css={{
                                                    justifyContent: 'space-evenly'
                                                }}>
                                                    <Typography variant="body2"
                                                                style={{paddingRight: '5px'}}>
                                                        <strong>{dayOfWeek}</strong>
                                                    </Typography>
                                                    <Box display="flex" alignItems="center"
                                                         flexDirection="column" css={{
                                                        justifyContent: 'space-between'
                                                    }}>
                                                        {ranges.map(range => {
                                                            const {opening, closing} = range;
                                                            return (

                                                                <Typography
                                                                    key={opening.toString()}
                                                                    variant="body2"
                                                                    style={{paddingBottom: '5px'}}>
                                                                    {setTime(opening)} - {setTime(closing)}
                                                                </Typography>
                                                            );
                                                        })}
                                                    </Box>
                                                </Box>
                                            </ListItemText>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                );
            })}
        </>
    );
}

export default ScheduleInStatesCard;
